// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__16646","image":"styles_image__3-pJu","text":"styles_text__22Jsg"};